import {useEffect, useState} from 'react';
import injectSheet from 'react-jss';
import {formatDate} from '@deliveriesondemand/dod-utils';

import greetingStyles from '-/styles/sections/greeting';
import NotMe from '-/components/general/NotMe';
import {getPartialInfoForMultipleOffers} from '-/api/api';
import {get} from '-/util/lodash';
import {getMyOffers} from '-/util/util';

const styles = theme => ({
    ...greetingStyles(theme),
    myoffers: {
        marginTop: 50,
        marginBottom: 50
    },
    offertable: {
        textAlign: 'left',
        margin: '0 auto',
        width: '90%',
        background: '#efefef',
        border: 'solid 2px #dadada',
        padding: 20
    },
    offertableRow: {
        display: 'flex'
    },
    offertableLabel: {
        flex: 1,
        fontWeight: 'bold',
        padding: '10px 0'
    },
    offertableValue: {
        flex: 3,
        padding: '10px 0'
    }
});

const Me = props => {
    const {classes = {}} = props;
    const [loading, setLoading] = useState(true);
    const [offers, setOffers] = useState([]);
    const offerIds = getMyOffers();

    useEffect(() => {
        if (offerIds.length === 0) {
            setLoading(false);
            return;
        }

        const fetchOffers = async() => {
            const results = await getPartialInfoForMultipleOffers(offerIds);
            const offers = get(results, 'data.offers') || [];

            setOffers(offers);
            setLoading(false);
        };

        fetchOffers();
    }, []);

    return (
        <section className={classes.root}>
            <h1>My Offers</h1>
            {loading && (
                <div className={classes.myoffers}>Loading your offers...</div>
            )}
            {!loading && offers.length === 0 && (
                <div className={classes.myoffers}>No offers found</div>
            )}
            {!loading && offers.length > 0 && (
                <div className={classes.myoffers}>
                    {offers.map(offer => {
                        const {
                            _id,
                            applicantName,
                            canAccessStips,
                            coApplicantName,
                            hasDocuments,
                            isFinalized,
                            isSubmitted,
                            make,
                            model,
                            submittedAt,
                            year
                        } = offer;

                        let status, vehicle;
                        const name = coApplicantName ? `${applicantName} & ${coApplicantName}` : applicantName;
                        
                        if (year && make && model) {
                            vehicle = `${year} ${make} ${model}`;
                        }

                        if (isSubmitted) {
                            status = `Submitted (${formatDate(submittedAt, 'MM/DD/YYYY')})`;
                        } else if (isFinalized) {
                            status = 'Complete';
                        }

                        return (
                            <div key={_id}>
                                <div className={classes.offertable}>
                                    <div className={classes.offertableRow}>
                                        <div className={classes.offertableLabel}>
                                            Name
                                        </div>
                                        <div className={classes.offertableValue}>
                                            <a href={`/?offerId=${_id}`}>{name}</a> {status && `(${status})`}
                                        </div>
                                    </div>
                                    {vehicle && (
                                        <div className={classes.offertableRow}>
                                            <div className={classes.offertableLabel}>
                                                Vehicle
                                            </div>
                                            <div className={classes.offertableValue}>
                                                {vehicle}
                                            </div>
                                        </div>
                                    )}
                                    {canAccessStips && (
                                        <div className={classes.offertableRow}>
                                            <div className={classes.offertableLabel} />
                                            <div className={classes.offertableValue}>
                                                <a href={`/?offerId=${_id}&stips=app`}>View/Upload Stips</a>
                                            </div>
                                        </div>
                                    )}
                                    {hasDocuments && (
                                        <div className={classes.offertableRow}>
                                            <div className={classes.offertableLabel} />
                                            <div className={classes.offertableValue}>
                                                <a href={`/?offerId=${_id}&t=documents`}>View Documents</a>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
            <NotMe />
        </section>
    );
};

export default injectSheet(styles)(Me);
